module.exports = __webpack_public_path__ + "img/puzzle7.jpg";